import { Divider, Box } from '@mui/material';
import classes from '../ccf-call-conference.module.scss';
import { CcfButton } from '@nice-ccf/ui-controls';

interface UserConferenceFooterProps {
  status: string;
  dispatchResetState: () => void;
}

/**
 * Component to be used for user conference footer
 * @param props - UserConferenceFooterProps
 * @example <UserConferenceFooter />
 * @returns
 */
export const UserConferenceFooter = (props: UserConferenceFooterProps) => {
  const { status, dispatchResetState } = props;
  return (
    <div>
      {status === 'conference' && (
        <>
          <Divider classes={{ root: classes.divider }} />
          <Box
            display="flex"
            boxShadow="0px 1px 0px #DAE2E8"
            border="1px solid #DAE2E8"
            margin="auto"
            width="fill-content"
            justifyContent="center"
            borderRadius={3}
            px={0.5}
          >
            <CcfButton
              variant="text"
              size="small"
              onClick={dispatchResetState}
              classes={{
                root: classes.footerButton,
                textSizeSmall: classes.footerText,
              }}
            >
              Leave Conference
            </CcfButton>
          </Box>
        </>
      )}
    </div>
  );
};
